import store from "@/store";
export const option = {
  height: "auto",
  calcHeight: 80,
  tree: true,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: true,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: false,
  selection: false,
  viewBtn: false,
  dialogType: "dialog",
  dialogClickModal: false,
  rowKey: (record)=>{return record.rentTypeName + ':' + record.id},
  column: [
    {
      label: "保证金公司名称",
      prop: "securityDeptName",
      type: "input",
      search: true,
      searchOrder: 100,
      span: 24,
      searchLabelWidth: 120,
      rules: [
        {
          required: true,
          message: "请输入保证金公司名称",
          trigger: "blur",
        },
      ],
    },
    {
      label: "公司名称",
      prop: "deptId",
      type: "select",
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 10,
      hide: true,
      dicData: [],
      props: {
        label: "deptName",
        value: "id",
      },
    },
    {
      label: "绑定公司",
      prop: "deptIds",
      type: "select",
      span: 24,
      filterable: true,
      search: false,
      multiple: true,
      hide: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 10,
      dicData: [],
      props: {
        label: "deptName",
        value: "id",
      },
      rules: [
        {
          required: true,
          message: "请选择绑定公司",
          trigger: "change",
        },
      ],
    },
    {
      label: "选择产品",
      prop: "rentTypes",
      type: "checkbox",
      span: 24,
      search: false,
      hide: true,
      searchOrder: 10,
      dicData: store.getters.porductTypes,
      rules: [
        {
          required: true,
          message: "选择产品",
          trigger: "change",
        },
      ],
    },
    {
      label: "id",
      prop: "id",
      display: false,
      hide: true,
    },
    {
      label: "loanSecurityDeptTypeId",
      prop: "loanSecurityDeptTypeId",
      display: false,
      hide: true,
    },
    {
      label: "产品类型",
      prop: "rentType",
      type: "select",
      display: false,
      hide: true,
      dicData: store.getters.porductTypes,
    },
    {
      label: "保证金名称",
      prop: "businessCode",
      span: 24,
      hide: true,
      display: false,
    },
    {
      label: "绑定公司",
      prop: "deptIdName",
      span: 24,
      search: false,
      display: false,
      hide: false,
    },

    {
      label: "产品名称",
      prop: "rentType",
      search: true,
      type: "select",
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      display: false,
      hide: true,
      dicData: store.getters.porductTypes,
    },
    {
      label: "产品名称",
      prop: "rentTypeName",
      display: false,
    },
    {
      label: "杠杆比例",
      prop: "leverageRatio",
      display: false,
      formatter: (val, value, label) => {
        return value || '--'
      },
    },
    {
      label: "保证金金额",
      prop: "securityMoney",
      display: false,
    },
    {
      label: "保证金余额",
      prop: "securityMoneyBalance",
      search: false,
      type: "select",
      display: false,
      dicData: [],
    },
    {
      // label: "保证金存量占用金额",
      label: '保证金占用额',
      prop: "securityMoneyStockOccupy",
      display: false,
    },
    {
      label: "保证金抵扣金额",
      prop: "securityMoneyDeductionOccupy",
      display: false,
    },
    {
      label: "租赁金额合计",
      prop: "leaseAmount",
      display: false,
    },
  ],
};
